import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Button } from "@mui/material";
import { BANNER_CONTROL_HEIGHT } from "../../straightener-common/constants";

interface Props {
	// A recipe is selected: Edit Recipe only exists when there is one to edit.
	hasRecipe: boolean;
	// Create needs a product to create the recipe for.
	canCreate: boolean;
	onEdit: () => void;
	onCreate: () => void;
}

// The recipe actions at the right end of the banner: Edit Recipe · Create Recipe.
// The labels name the recipe because the buttons sit far from the picker they
// act on. Send to PLC is not here: it acts on the recipe the picker shows, so it
// sits next to the picker. Height comes from the shared banner constant, the same
// one the recipe picker uses — MUI's "small" Button and "small" Autocomplete are
// not the same height.
export const RecipeActionsBar = ({
	hasRecipe,
	canCreate,
	onEdit,
	onCreate,
}: Props) => (
	<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
		{hasRecipe ? (
			<Button
				variant="outlined"
				color="primary"
				size="small"
				startIcon={<EditIcon />}
				onClick={onEdit}
				sx={{ height: BANNER_CONTROL_HEIGHT }}
			>
				EDIT RECIPE
			</Button>
		) : null}
		{canCreate ? (
			<Button
				variant="contained"
				color="primary"
				size="small"
				startIcon={<AddIcon />}
				onClick={onCreate}
				sx={{ height: BANNER_CONTROL_HEIGHT }}
			>
				CREATE RECIPE
			</Button>
		) : null}
	</Box>
);
